import React from 'react';
import { Github, Linkedin, Mail, MapPin, Download } from 'lucide-react';
import { Button } from '../components/ui/button';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero-section min-h-screen flex items-center justify-center px-6 py-20">
      <div className="max-w-6xl mx-auto w-full">
        <div className="hero-content space-y-8 animate-fade-in">
          <div className="space-y-4">
            <div className="inline-block">
              <span className="text-cyan-400 font-mono text-sm tracking-wider animate-pulse">
                &lt;hello world /&gt;
              </span>
            </div>
            <h1 className="text-5xl md:text-7xl font-bold text-white leading-tight">
              Ahmet Oğulcan
              <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500">
                Çankaya
              </span>
            </h1>
            <p className="text-2xl md:text-3xl text-gray-300 font-medium">
              DevOps Engineer & Backend Developer
            </p>
            <p className="text-lg text-gray-400 max-w-2xl">
              Automating, optimizing, and securing cloud deployments with 4+ years of experience.
              Building scalable infrastructure with Kubernetes, AWS, and modern DevOps practices.
            </p>
          </div>

          <div className="flex flex-wrap gap-4 items-center">
            <Button
              onClick={scrollToContact}
              className="bg-cyan-500 hover:bg-cyan-600 text-white px-8 py-6 text-lg rounded-full transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-cyan-500/50"
            >
              Get In Touch
            </Button>
            <Button
              variant="outline"
              className="border-2 border-cyan-400 text-cyan-400 hover:bg-cyan-400/10 px-8 py-6 text-lg rounded-full transition-all duration-300 hover:scale-105"
              asChild
            >
              <a href="#experience">View Experience</a>
            </Button>
          </div>

          <div className="flex flex-wrap gap-6 items-center pt-4">
            <a
              href="https://github.com/AhmetOgulcanCankaya"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-gray-400 hover:text-cyan-400 transition-colors duration-300 group"
            >
              <Github className="w-5 h-5 group-hover:scale-110 transition-transform duration-300" />
              <span>GitHub</span>
            </a>
            <a
              href="https://www.linkedin.com/in/ahmet-ogulcan-cankaya/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-gray-400 hover:text-cyan-400 transition-colors duration-300 group"
            >
              <Linkedin className="w-5 h-5 group-hover:scale-110 transition-transform duration-300" />
              <span>LinkedIn</span>
            </a>
            <a
              href="mailto:ahmetogulcancankaya@gmail.com"
              className="flex items-center gap-2 text-gray-400 hover:text-cyan-400 transition-colors duration-300 group"
            >
              <Mail className="w-5 h-5 group-hover:scale-110 transition-transform duration-300" />
              <span>Email</span>
            </a>
            <div className="flex items-center gap-2 text-gray-400">
              <MapPin className="w-5 h-5" />
              <span>Bucharest, Romania</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;